import { useEffect, useState, Fragment } from "react"

import { ClientDiscount } from "utils/interfaces"
import { sortDiscounts } from "utils/helpers"
import { DiscountFormatter } from "modules/discount/DiscountFormatter"
import { DiscountListItem } from "modules/discount/DiscountListItem"
import { INITIATOR } from "modules/discount/constants"
import { useShowPrice } from "utils/hooks/useShowPrice"

interface Props {
    selectedDiscount?: number
    collapsed?: boolean
    showSelect?: boolean
    hasPreviousSessions?: boolean
    discounts?: ClientDiscount[]
    initiator?: INITIATOR
    onDiscountChange?: (discountId: number | undefined) => void
}

export const DiscountList = (props: Props) => {
    const [discounts, setDiscounts] = useState<ClientDiscount[]>([])
    const showPrice = useShowPrice()

    useEffect(() => {
        if (!props.discounts) {
            setDiscounts([])
            return
        }
        setDiscounts(sortDiscounts(props.discounts))
    }, [props.discounts])

    return (
        <>
            <div className="is-flex is-flex-direction-column discount__list mt-2">
                {discounts.map((discount, index) => (
                    <Fragment key={discount.discount_id}>
                        {(!props.collapsed || index === 0) && (
                            <DiscountListItem
                                view={props.collapsed ? "minimal" : "extended"}
                                id={discount.discount_id}
                                title={new DiscountFormatter(discount).getName()}
                                description={new DiscountFormatter(discount).getDescription(
                                    props.initiator
                                )}
                                showSelect={props.showSelect}
                                selectedDiscount={props.selectedDiscount}
                                onDiscountChange={props.onDiscountChange}
                                group={discount.group}
                                initiator={props.initiator}
                                hasPreviousSessions={props.hasPreviousSessions}
                                can_be_applied={discount.can_be_applied}
                            />
                        )}
                    </Fragment>
                ))}
                {!props.collapsed && showPrice && (
                    <DiscountListItem
                        view="extended"
                        title="Промокод"
                        showSelect={props.showSelect}
                        selectedDiscount={props.selectedDiscount}
                        onDiscountChange={props.onDiscountChange}
                        initiator={props.initiator}
                        can_be_applied
                    />
                )}
            </div>
        </>
    )
}
